import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Leapmobileapp() {
  return (
    <section className="work_it_staff p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="resp_order my-auto"
          >
            <StaticImage
              src="../../images/services-usa/mobile-app/mobile_app_leap.webp"
              alt="mobile application development company"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={646}
              height={648}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <h2>
              High-Caliber <span>App Development</span> at Your Fingertips
            </h2>
            <p>
              Our mobile application development services are designed to
              accelerate app production and upscale performance quality. From
              high-fidelity wireframe designs to robust, cyber-secure solutions,
              our full-cycle app development company is your transformation
              partner. Our full-stack app engineers excel at executing complex
              mobile app development projects, whether for native or
              cross-platform applications.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Start with a Free Consultation
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Leapmobileapp;
